export enum SubscriptionType {
  Main = 'Main',
  Regional = 'Regional',
  Unique = 'Unique',
}
